export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.Fans_admin_dashboard_language = payload;
  },
  // END:: SET APP LOCALE
};
